import FolderOffIcon from "@/assets/icons/folder_off.svg?react";
import CompactInsightCard from "./CompactInsightCard";
import InstructionsCard from "./InstructionsCard";
import ExpandedInsightCard from "./ExpandedInsightCard";
import { useUser } from "@/contexts/UserContext";
import { InsightProps } from "./insights";

type InsightListProps = {
  insights: InsightProps[];
  isActive: boolean;
  compactMode: boolean;
  onOpenDrawer: (insight: InsightProps) => void;
  onOpenEditModal: (insight: InsightProps) => void;
  onOpenDeleteModal: (insight: InsightProps) => void;
  onOpenDeleteAlertModal: (insight: InsightProps) => void;
  onArchiveInsight: (insight: InsightProps) => void;
  onActivateInsight: (insight: InsightProps) => void;
  onOpenAddAlertModal: (insight: InsightProps) => void;
  onOpenShareModal?: (insight: InsightProps) => void;
};

export default function InsightList({
  insights,
  isActive,
  compactMode,
  onOpenDrawer,
  onOpenEditModal,
  onOpenDeleteModal,
  onOpenDeleteAlertModal,
  onArchiveInsight,
  onActivateInsight,
  onOpenAddAlertModal,
  onOpenShareModal,
}: InsightListProps) {
  const { userInfo } = useUser();
  const userName = userInfo
    ? `${userInfo.first_name} ${userInfo.last_name}`.trim()
    : undefined;
  if (insights?.length === 0 && !isActive) {
    return (
      <div className="flex flex-col items-center justify-center text-[#00000073] text-base gap-2 mt-8">
        <FolderOffIcon />
        No archived insights
      </div>
    );
  }
  if (insights?.length === 0 && isActive) {
    return <InstructionsCard />;
  }

  return (
    <div className="grid grid-cols-1 gap-3">
      {insights.map((insight) =>
        compactMode ? (
          <CompactInsightCard
            key={insight.id}
            insight={insight}
            onOpenDrawer={onOpenDrawer}
            onOpenEditModal={() => onOpenEditModal(insight)}
            onOpenDeleteModal={() => onOpenDeleteModal(insight)}
            onOpenDeleteAlertModal={() => onOpenDeleteAlertModal(insight)}
            onArchiveInsight={() => onArchiveInsight(insight)}
            onActivateInsight={() => onActivateInsight(insight)}
            onOpenAddAlertModal={() => onOpenAddAlertModal(insight)}
            userName={userName}
            onOpenShareModal={
              onOpenShareModal ? () => onOpenShareModal(insight) : undefined
            }
          />
        ) : (
          <ExpandedInsightCard
            key={insight.id}
            insight={insight}
            onOpenDrawer={onOpenDrawer}
            onOpenEditModal={() => onOpenEditModal(insight)}
            onOpenDeleteModal={() => onOpenDeleteModal(insight)}
            onOpenDeleteAlertModal={() => onOpenDeleteAlertModal(insight)}
            onArchiveInsight={() => onArchiveInsight(insight)}
            onActivateInsight={() => onActivateInsight(insight)}
            onOpenAddAlertModal={() => onOpenAddAlertModal(insight)}
            userName={userName}
            onOpenShareModal={
              onOpenShareModal ? () => onOpenShareModal(insight) : undefined
            }
          />
        ),
      )}
    </div>
  );
}
